<template>
    <div style="height: calc(100vh - 45px); overflow: scroll; padding: 0 10px;">
      <!-- 班级选择器卡片 -->
      <div class="class-selector glass-panel" @click="openClassPicker">
        <div class="selector-content">
          <span class="label">当前班级</span>
          <div class="value">
            {{ searchObj.className || '点击选择班级' }}
            <van-icon name="arrow-down" size="12" />
          </div>
        </div>
      </div>

      <van-dropdown-menu style="margin-bottom: 8px;">
        <van-dropdown-item v-model="searchObj.searchFaceStatus" :options="option1" />
      </van-dropdown-menu> 

      <!-- 班级选择器弹窗 (年级快捷胶囊栏 + 班级滚轮) -->
      <van-popup v-model="classShowPicker" round position="bottom" class="glass-popup" @close="onCancelPicker">
        <div class="popup-header">
          <div class="btn cancel" @click="onCancelPicker">取消</div>
          <div class="title">选择班级</div>
          <div class="btn confirm" @click="onConfirmPicker">确定</div>
        </div>

        <!-- 年级快捷胶囊栏 -->
        <div v-if="gradeList && gradeList.length > 1" class="grade-capsule-bar">
          <div class="grade-scroll-wrap">
            <div 
              v-for="grade in gradeList" 
              :key="grade.code"
              class="grade-pill"
              :class="{ active: tempGrade === grade.code }"
              @click="handleGradePillClick(grade.code)"
            >
              <span class="grade-name">{{ grade.name }}</span>
              <span class="grade-count">({{ grade.count }})</span>
            </div>
          </div>
        </div>

        <van-picker 
          ref="classPicker" 
          :columns="filteredClassList" 
          :default-index="currentClassIndex" 
          :show-toolbar="false" 
          item-height="44" 
        />
      </van-popup>

      <van-index-bar>
        <div v-for="(item, i) in indexList" :key="i">
          <van-index-anchor :index="item.title" />
          <van-cell :title="itemc.studentName" :label="itemc.snCode" is-link @click="goInfo(itemc)" v-for="(itemc, ic) in item.datas" :key="ic">
            <template #default>
              <van-tag type="success" v-if="+itemc.faceStatus > 0">已制证</van-tag>
              <van-tag type="danger" v-else>未制证</van-tag>
            </template>
          </van-cell>
        </div>
      </van-index-bar>
    </div>
  </template>
  
  <script>
  import { getClassInfoList, getStudentInfoList } from "../../api/teacherAttendanceCall.js";
  import { setSession, getSession, removeSession } from "@/utils/cookie";
  import Pinyin from './pinyin.js';

  export default {
    data() {
      return {
        dropdownValue: '',
        dropdownOption: [ 
          { text: '全部', value: '' },
          { text: '引体向上', value: 'PullUp' },
          { text: '立定跳远', value: 'Jump' },
          { text: '坐位体前屈', value: 'SitAndReach' },
          { text: '仰卧起坐', value: 'SitUp' },
          { text: '体重/身高', value: 'HeightWeight' },
          { text: '肺活量', value: 'VitalCapacity' },
          { text: '双杠臂屈伸', value: 'TricepsDip' },
          { text: '纵跳摸高', value: 'TricepsDip' },
        ],
        searchShow: false,
        searchStr: "",

        tabList: [
          { name: "待审核", value: "0" },
          { name: "通过", value: "2" },
          { name: "驳回", value: "3" },
        ],
        dataList: [],
        pageIndex: 1,
        pageSize: 10,
        loading: false,
        finished: false,
        wfType: "0",
        reqType: null,
        allClassList: [],
        classShowPicker: false,
        tempGrade: 'ALL',
        searchObj: {
          className: '',
          classCode: '',
          studentName: '',
          searchFaceStatus: 'all',
          selectedGrade: 'ALL'
        },
        indexList: [],
        option1: [
          { text: '全部（未制证+已制证）', value: 'all' },
          { text: '未制证', value: 0 },
          { text: '已制证', value: 1 },
        ],
      };
    },
    computed: {
      gradeList() {
        if (!this.allClassList || this.allClassList.length === 0) return [];
        const map = new Map();
        this.allClassList.forEach(item => {
          const key = item.gradeKey;
          const name = item.gradeName || '未分年级';
          if (!map.has(key)) {
            map.set(key, { code: key, name: name, count: 0 });
          }
          map.get(key).count++;
        });
        return [
          { code: 'ALL', name: '全部年级', count: this.allClassList.length },
          ...Array.from(map.values())
        ];
      },
      filteredClassList() {
        if (!this.tempGrade || this.tempGrade === 'ALL') {
          return this.allClassList;
        }
        return this.allClassList.filter(item => item.gradeKey === this.tempGrade);
      },
      currentClassIndex() {
        if (!this.searchObj.classCode || !this.filteredClassList.length) return 0;
        let idx = this.filteredClassList.findIndex(item => 
          item.value === this.searchObj.classCode && 
          (!this.searchObj.className || item.text === this.searchObj.className)
        );
        if (idx < 0) {
          idx = this.filteredClassList.findIndex(item => item.value === this.searchObj.classCode);
        }
        return idx >= 0 ? idx : 0;
      }
    },
    beforeRouteLeave(to, from, next) {
      if (!to || !to.path || to.path.indexOf('addFaceInfo') === -1) {
        removeSession('teacherAttendanceCall/index');
      }
      next();
    },
    filters: {
      stateFil(val) {
        const obj = {
          "1": "待审核",
          "2": "审核通过",
          "3": "审核驳回",
          "4": "作废",
        };
        if (val) {
          return obj[val];
        } else {
          return "待提交";
        }
      },
      appealTypeFil(val) {
        const obj = {
          "1": "未识别人脸",
          "2": "未经过点位",
          "3": "未检录",
        };
        if (val) {
          return obj[val];
        } else {
          return "";
        }
      },
    },
    created() {
      this.loading = true;
      this.finished = false;
      this.pageIndex = 1;
      this.pageSize = 10;
      this.setupList = [];
      this.init();
      const cache = getSession('teacherAttendanceCall/index');
      if (cache) {
        try {
          const cachedObj = JSON.parse(cache);
          this.searchObj = Object.assign({}, this.searchObj, cachedObj);
        } catch (e) {}
        if (this.searchObj.searchFaceStatus === undefined) {
          this.searchObj.searchFaceStatus = 'all';
        }
        if (!this.searchObj.selectedGrade) {
          this.searchObj.selectedGrade = 'ALL';
        }
        if (this.searchObj.classCode) {
          this.getList();
        }
      }
    },
    watch: {
      'searchObj.searchFaceStatus'() {
        if (!this.searchObj.classCode || this.searchObj.classCode === '') {
          this.$notify({ type: "warning", message: '请选择班级！' });
          return;
        }
        this.getList();
      }
    },
    methods: {
      goInfo(row) {
        setSession('teacherAttendanceCall/index', JSON.stringify(this.searchObj));
        this.$router.push({ path: 'teacherAddFaceIn/addFaceInfo', query: { studentInfo: JSON.stringify(row) } });
      },
      openClassPicker() {
        this.tempGrade = this.searchObj.selectedGrade || 'ALL';
        this.classShowPicker = true;
        this.$nextTick(() => {
          this.$nextTick(() => {
            if (this.$refs.classPicker && typeof this.$refs.classPicker.setColumnIndex === 'function') {
              this.$refs.classPicker.setColumnIndex(0, this.currentClassIndex);
            }
          });
        });
      },
      handleGradePillClick(gradeCode) {
        if (this.tempGrade === gradeCode) return;
        this.tempGrade = gradeCode;
        this.$nextTick(() => {
          this.$nextTick(() => {
            if (this.$refs.classPicker && typeof this.$refs.classPicker.setColumnIndex === 'function') {
              let targetIdx = 0;
              if (this.searchObj.classCode) {
                const foundIdx = this.filteredClassList.findIndex(item => item.value === this.searchObj.classCode);
                if (foundIdx >= 0) {
                  targetIdx = foundIdx;
                }
              }
              this.$refs.classPicker.setColumnIndex(0, targetIdx);
            }
          });
        });
      },
      onCancelPicker() {
        this.classShowPicker = false;
        this.tempGrade = this.searchObj.selectedGrade || 'ALL';
      },
      onConfirmPicker() {
        if (this.$refs.classPicker) {
          if (typeof this.$refs.classPicker.confirm === 'function') {
            this.$refs.classPicker.confirm();
          }
          let val = null;
          if (typeof this.$refs.classPicker.getValues === 'function') {
            const vals = this.$refs.classPicker.getValues();
            val = vals && vals[0];
          }
          if (!val && typeof this.$refs.classPicker.getColumnIndex === 'function') {
            const cIdx = this.$refs.classPicker.getColumnIndex(0);
            val = this.filteredClassList[cIdx];
          }
          if (!val && this.filteredClassList.length > 0) {
            val = this.filteredClassList[0];
          }
          if (val) {
            this.searchObj.selectedGrade = this.tempGrade || 'ALL';
            this.searchObj.classCode = val.value;
            this.searchObj.className = val.text;
            this.getList();
            this.classShowPicker = false;
            setSession('teacherAttendanceCall/index', JSON.stringify(this.searchObj));
            return;
          }
        }
        this.classShowPicker = false;
      },
      init() {
        getClassInfoList({}).then(res => {
          const rawList = (res && res.data && res.data.data) || [];
          const seen = new Set();
          const uniqueList = [];
          rawList.forEach(item => {
            if (item && item.classCode) {
              const text = `${(item.gradeName || '').trim()}-${(item.className || '').trim()}`.trim() || item.className;
              const key = `${item.classCode}_${text}`;
              if (!seen.has(key)) {
                seen.add(key);
                uniqueList.push({
                  text: text,
                  className: item.className,
                  value: item.classCode,
                  gradeCode: item.gradeCode,
                  gradeName: (item.gradeName || '').trim(),
                  gradeKey: String(item.gradeCode || item.gradeName || 'other')
                });
              }
            }
          });
          this.allClassList = uniqueList;
        }).catch(() => {});
      },
      getList() {
        getStudentInfoList({
          classCode: this.searchObj.classCode,
          studentName: this.searchObj.studentName,
        }).then(res => {
          this.dataList = (res && res.data && res.data.data) || [];
          this.dropdownItemChange();
        }).catch(() => {});
      },
      pinyinSort(name) {
        var pinyinArray = new Array();
        for (var bukn = 0; bukn < name.length; bukn++) {
          var o = new Object();
          var ken = Pinyin.getSpell(name[bukn].studentName, function(charactor, spell) {
            return spell[1];
          });
          o.studentName = name[bukn];
          o.pinyin = ken.split(',').join('');
          pinyinArray.push(o);
        }
        let map = {
          title: '',
          datas: []
        };
        pinyinArray.forEach((item, index) => {
          if (!map[item.pinyin[0].toUpperCase()]) {
            map[item.pinyin[0].toUpperCase()] = {
              title: item.pinyin[0].toUpperCase(),
              datas: []
            };
          }
          map[item.pinyin[0].toUpperCase()].datas.push({
            ...item.studentName,
            pinyin: item.pinyin
          });
        });
        var turn = new Array();
        var letters = '*ABCDEFGHIJKLNMOPQRSTUVWXYZ'.split('');
        for (var i = 1; i < letters.length; i++) {
          if (map[letters[i]]) {
            var obj = new Object();
            obj.title = letters[i];
            obj.datas = map[letters[i]].datas;
            turn.push(obj);
          }
        }
        let arr = turn;
        var compare = function(obj1, obj2) {
          var val1 = obj1.pinyin;
          var val2 = obj2.pinyin;
          if (val1 < val2) {
            return -1;
          } else if (val1 > val2) {
            return 1;
          } else {
            return 0;
          }
        };
        for (let i = 0; i < arr.length; i++) {
          arr[i].datas.sort(compare);
        }
        this.indexList = arr;
      },
      onStatus(e) {
        this.loading = true;
        this.finished = false;
        this.pageIndex = 1;
        this.pageSize = 10;
        this.dataList = [];
        this.indexList = [];
        this.wfType = e;
        this.onLoad();
      },
      dropdownItemChange() {
        if (this.searchObj.searchFaceStatus == 'all') {
          this.pinyinSort(this.dataList);
        } else if (+this.searchObj.searchFaceStatus == 0) {
          let dataListJson = this.dataList.filter(item => +item.faceStatus == 0);
          this.pinyinSort(dataListJson);
        } else if (+this.searchObj.searchFaceStatus > 0) {
          let dataListJson = this.dataList.filter(item => +item.faceStatus > 0);
          this.pinyinSort(dataListJson);
        }
        setSession('teacherAttendanceCall/index', JSON.stringify(this.searchObj));
      },
      dropdownChange() {
        this.loading = true;
        this.finished = false;
        this.pageIndex = 1;
        this.pageSize = 10;
        this.dataList = [];
        this.indexList = [];
        this.onLoad();
      },
      onLoad() {
        this.reqType.post(`/runGroupAppeal/listRunGroupAppeal?pageNumber=${this.pageIndex}&rowNumber=${this.pageSize}`, {
          appealStatus: this.wfType,
          detectionType: this.dropdownValue,
        }).then(res => {
          if (res.header.code == 0) {
            if (res.body.list.length > 0) {
              res.body.list.forEach(el => {
                switch (el.detectionType) {
                  case 'HeightWeight': el.detectionTypeName = '体重/身高'; el.preFinishSecondsName = el.preFinishSeconds + 'BMI'; break;
                  case 'TZ': el.detectionTypeName = '体重'; el.preFinishSecondsName = el.preFinishSeconds + 'KG'; break;
                  case 'VitalCapacity': el.detectionTypeName = '肺活量'; el.preFinishSecondsName = el.preFinishSeconds + 'ML'; break;
                  case 'Jump': el.detectionTypeName = '立定跳远'; el.preFinishSecondsName = el.preFinishSeconds + 'CM'; break;
                  case 'PullUp': el.detectionTypeName = '引体向上'; el.preFinishSecondsName = el.preFinishSeconds + '个'; break;
                  case 'SitUp': el.detectionTypeName = '仰卧起坐'; el.preFinishSecondsName = el.preFinishSeconds + '个'; break;
                  case 'SitAndReach': el.detectionTypeName = '坐位体前屈'; el.preFinishSecondsName = el.preFinishSeconds + 'CM'; break;
                  case 'TricepsDip': el.detectionTypeName = '双杠臂屈伸'; break;
                  case 'LengthwaysJump': el.detectionTypeName = '纵跳摸高'; break;
                  case 'RUN50': el.detectionTypeName = '50米'; break;
                  case 'RUN800': el.detectionTypeName = '800米'; break;
                  case '1000米': el.detectionTypeName = 'RUN1000'; break;
                  default: el.detectionTypeName = '未知'; break;
                }
              });
              this.pageIndex++;
              this.dataList = this.dataList.concat(res.body.list);
              this.loading = false;
            } else {
              this.finished = true;
            }
          }
        });
      },
    },
  };
  </script>
  
  <style lang="less" scoped>
  /* 班级选择器卡片 */
  .class-selector {
    margin: 8px 0 10px;
  }
  .glass-panel {
    background: rgba(255, 255, 255, 0.9);
    border: 1px solid rgba(0, 0, 0, 0.08);
    border-radius: 12px;
    padding: 12px 16px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.04);
    cursor: pointer;
    
    &:active { opacity: 0.8; transform: scale(0.99); transition: all 0.2s; }

    .selector-content {
      display: flex; justify-content: space-between; align-items: center;
      .label { font-size: 14px; color: #8e8e93; }
      .value { font-size: 15px; font-weight: 600; color: #007AFF; display: flex; align-items: center; gap: 4px; }
    }
  }

  /* 底部弹窗 */
  .glass-popup { background: #f2f2f7; }
  .popup-header {
    display: flex; justify-content: space-between; align-items: center; padding: 12px 16px; background: #fff;
    .btn { font-size: 15px; cursor: pointer; }
    .cancel { color: #8e8e93; }
    .confirm { color: #007AFF; font-weight: 600; }
    .title { font-weight: 600; font-size: 16px; }
  }

  /* 年级快捷胶囊栏 */
  .grade-capsule-bar {
    padding: 10px 16px 8px;
    background: #fff;
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);

    .grade-scroll-wrap {
      display: flex;
      overflow-x: auto;
      gap: 8px;
      padding-bottom: 2px;
      
      /* 隐藏滚动条 */
      &::-webkit-scrollbar { display: none; width: 0; height: 0; }
      -ms-overflow-style: none;
      scrollbar-width: none;
    }

    .grade-pill {
      flex-shrink: 0;
      padding: 6px 14px;
      border-radius: 16px;
      font-size: 13px;
      background: rgba(118, 118, 128, 0.08);
      color: #636366;
      display: flex;
      align-items: center;
      gap: 4px;
      cursor: pointer;
      transition: all 0.25s cubic-bezier(0.25, 0.8, 0.25, 1);
      font-weight: 500;

      .grade-count {
        font-size: 11px;
        opacity: 0.75;
      }

      &.active {
        background: #007AFF;
        color: #fff;
        font-weight: 600;
        box-shadow: 0 2px 8px rgba(0, 122, 255, 0.3);

        .grade-count {
          opacity: 0.9;
        }
      }

      &:active {
        transform: scale(0.96);
      }
    }
  }

  .boxlist {
    padding: 6px;
    margin: 6px;
    border: 1px solid #ccc;
    border-radius: 10px;
    background-color: #fff;
    font-size: 14px;
    color: #323233;
    line-height: 24px;
    box-shadow: inset calc(-1px * var(--dir-factor)) 0 0 rgba(0, 0, 0, 0.25);
  }
  ::v-deep .van-cell__label {
    color: #1a1a1a;
  }
  ::v-deep .van-index-bar__index {
    font-size: 16px;
    line-height: 19px;
  }
  </style>
